
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorResourcesNavigationVue from "@/components/administrator/resources/navigation.vue";
import AppAdministratorResourcesExercisesListIndexVue from "@/views/app/administrator/resources/exercises/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorResourcesNavigationVue,
    AppAdministratorResourcesExercisesListIndexVue,
  },
})
export default class AppAdministratorResourcesExercisesIndexVue extends Vue {}
